import * as Tabs from '@radix-ui/react-tabs';
import React from 'react';
import { Box } from '../Box/Box';
import { Grid } from '../Grid/Grid';
import { TabList } from './Tab.styled';
import { TabButton } from './TabButton';
import { TabChip } from './TabChip';
import { TabRadio } from './TabRadio';
export const Tab = ({
  tabsData,
  orientation = 'horizontal',
  size = 'md',
  type = 'button',
  border = false,
  tabGap,
  isTransparent = false,
  dynamicTabWidth = false,
  ariaLabel = 'Tabs',
  defaultValue = tabsData[0].id,
  buttonChipProps
}) => {
  const [isActive, setIsActive] = React.useState(`${defaultValue}`);
  function onTabSelect(tab) {
    setIsActive(tab.id);
    tab.onTabSelect();
  }
  const renderTab = tab => {
    switch (type) {
      case 'chip':
        return React.createElement(TabChip, {
          isActive: isActive,
          onTabSelect: () => {
            onTabSelect(tab);
          },
          dynamicTabWidth: dynamicTabWidth,
          tab: tab,
          size: size,
          buttonChipProps: buttonChipProps
        });
      case 'button':
        return React.createElement(TabButton, {
          onTabSelect: () => {
            onTabSelect(tab);
          },
          dynamicTabWidth: dynamicTabWidth,
          isTransparent: isTransparent,
          border: border,
          tab: tab,
          size: size
        });
      case 'radio':
        return React.createElement(TabRadio, {
          onTabSelect: () => {
            onTabSelect(tab);
          },
          tab: tab,
          isActive: isActive
        });
    }
  };
  const gridProps = dynamicTabWidth => {
    switch (dynamicTabWidth) {
      case true:
        return {
          autoFlow: 'column',
          columnGap: tabGap
        };
      case false:
        return {
          autoFlow: 'column',
          autoColumns: 'max-content',
          columnGap: tabGap
        };
    }
  };
  if (orientation === 'vertical') {
    return React.createElement(Tabs.Root, {
      defaultValue: `tab-${defaultValue}`
    }, React.createElement(TabList, {
      orientation: 'vertical',
      "aria-label": ariaLabel
    }, React.createElement(Grid, {
      gap: tabGap
    }, tabsData.map((tab, index) => React.createElement(React.Fragment, null, renderTab(tab))))), React.createElement(Box, null, tabsData.map(tab => {
      return React.createElement(Tabs.Content, {
        key: `tab-${tab.id}`,
        value: `tab-${tab.id}`
      }, tab.children);
    })));
  }
  return React.createElement(Tabs.Root, {
    defaultValue: `tab-${defaultValue}`
  }, React.createElement(TabList, {
    orientation: orientation,
    "aria-label": ariaLabel
  }, React.createElement(Grid, {
    ...gridProps(dynamicTabWidth)
  }, tabsData.map(tab => {
    return renderTab(tab);
  }))), React.createElement(Box, null, tabsData.map(tab => {
    return React.createElement(Tabs.Content, {
      key: `tab-${tab.id}`,
      value: `tab-${tab.id}`
    }, tab.children);
  })));
};
Tab.displayName = 'Tab';